import { legacy_createStore as createStore, combineReducers, applyMiddleware } from "redux"
import thunk from "redux-thunk";
import { authReducer } from "./Login/reducer";
import { MoviesReducer } from "./Movies/reducer";
import { registerReducer } from "./Registration/reducer";
import { ModeReducer } from "./Mode/reducer"; 
import videoEmoteReducer from './Video/reducer';
// Import the view queue reducer
import { viewQueueReducer } from './ViewQueue/reducer';
import { favoritesReducer } from './Favorites/reducer';
// Import the watch later reducer
import { watchLaterReducer } from './WatchLater/reducer';
// Import the video history reducer
import { videoHistoryReducer } from './VideoHistory/reducer';
// Import the comments reducer
import commentsReducer from './Comments/reducer';
// Import the ticket reducer
import ticketReducer from './Ticket/ticketReducer';
// Import the stability monitoring reducer
import stabilityReducer from './Admin/stabilityReducer';
// Import the chat reducer
import chatReducer from './Chat/reducer';
// Import the theme reducer
import themeReducer from './Theme/reducer';

const rootReducers = combineReducers({
    Movies: MoviesReducer,
    // Use only one reference to the auth reducer to avoid state synchronization issues
    auth: authReducer,
    register: registerReducer,
    Mode: ModeReducer,
    emotes: videoEmoteReducer,
    viewQueue: viewQueueReducer,
    favorites: favoritesReducer,
    watchLater: watchLaterReducer,
    videoHistory: videoHistoryReducer,
    comments: commentsReducer, // Add comments reducer to make it available in the store
    ticket: ticketReducer, // Add ticket reducer for handling admin inbox and user tickets
    stability: stabilityReducer, // Add stability monitoring reducer
    chat: chatReducer, // Add chat reducer for the chat functionality
    theme: themeReducer // Add theme reducer for chat background themes
})

export const store = createStore(
    rootReducers,
    applyMiddleware(thunk)
);

console.log("initial todos", store.getState())
